import { upsertGroupAttributes } from '@dispatch/shared/services';
import { useMutation } from 'react-query';

interface GroupAttributesPayload {
  id: string;
  attributeGroupName: string;
  tenantId: string;
  docType: string;
  groupMap: Record<string, Record<string, string>>;
}

export const useUpsertGroupAttributes = (
  onSuccess: ({ success }: { success: boolean; message?: string }) => void,
  tenantId: string | undefined
) => {
  const { mutate, error, status } = useMutation(
    ['upsert-group-attributes'],
    async (data: GroupAttributesPayload) => {
      if (!tenantId) {
        throw new Error('TenantId is required for creating group attributes');
      }
      return upsertGroupAttributes(data);
    },
    {
      onSuccess,
    }
  );

  return {
    upsertGroupAttributes: mutate,
    error,
    status,
  };
};
